import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=7f222c68&scoped=true"
import script from "./ConfirmButton.vue?vue&type=script&lang=ts"
export * from "./ConfirmButton.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmButton.vue?vue&type=style&index=0&id=7f222c68&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f222c68",
  null
  
)

export default component.exports